import { t } from '@web-solutions/module-localization';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import styles from './SuccessPayment.module.scss';
import { ReactComponent as BackIcon } from '../../../../assets/images/arrowLeft.svg';

const SuccessPayment = ({ onClose, showCheck }) => {
  return (
    <div className={styles.succesContainer}>
      {/* <div className={styles.back}>
        <button onClick={onClose}>
          <BackIcon />
        </button>
      </div> */}
      <div className={styles.container}>
        <div className={styles.circle}></div>
        {showCheck && (
          <svg className={styles.checkmark} viewBox='0 0 52 52'>
            <path
              className={styles.checkmarkPath}
              fill='none'
              stroke='#fff'
              strokeLinecap='round'
              stroke-linejoin='round'
              strokeWidth='6'
              d='M14 27 l10 10 l18 -18'
            />
          </svg>
        )}
      </div>
      <Title tag='h2'>{t('onboarding.upsaleThird.paymentSuccessful')}</Title>
      {/* <Text size='m' medium className={styles.subTitle}>
        {t('onboarding.upsaleThird.successSubtitle')}
      </Text> */}
    </div>
  );
};

export default SuccessPayment;
